import React from "react";
import { data } from "./data";
import { WorkList } from "./WorkList";

export const Work = () => {
  return (
    <div name="work" className="w-full md:h-screen text-gray-300 bg-navbar">
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 text-gray-300 border-pink-600">
            Work
          </p>
          <p className="py-6">Check out some of my recent work</p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
          {data.map(({ id, projectName, imgSrc, demoSrc, codeSrc }) => (
            <WorkList
              key={id}
              projectName={projectName}
              imgSrc={imgSrc}
              demoSrc={demoSrc}
              codeSrc={codeSrc}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
